import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CartItems = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.046 32.867c0 .905.703 1.708 1.708 1.708h28.419c.602 0 1.004.502 1.004 1.005 0 .602-.502 1.004-1.004 1.004h-3.415c.302.503.402 1.105.402 1.808 0 2.11-1.807 3.918-3.916 3.918-2.21 0-3.917-1.708-3.917-3.918 0-.703.201-1.305.502-1.808H20.385c.302.503.402 1.105.402 1.808 0 2.11-1.707 3.918-3.916 3.918-2.21 0-3.917-1.708-3.917-3.918 0-.703.201-1.305.502-1.808h-.702c-2.11 0-3.817-1.707-3.817-3.717 0-1.607 1.105-3.013 2.511-3.515L5.824 4.539h-4.82A1.006 1.006 0 0 1 0 3.535C0 3.033.502 2.53 1.004 2.53h5.624c.502 0 .904.302 1.004.804l5.925 25.817h24.201l4.218-19.79c.1-.603.703-.904 1.205-.803.502.1.904.703.803 1.205l-4.418 20.694c-.1.502-.502.803-1.004.803H12.754c-.904 0-1.708.703-1.708 1.607Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.323 9.06c0-.201-.1-.402-.2-.502-.603-1.407-2.01-2.411-3.716-2.411a4.03 4.03 0 0 0-4.017 4.018 4.03 4.03 0 0 0 4.017 4.018c.703 0 1.405-.2 2.008-.603-.502 2.31-2.21 4.22-4.519 5.123-.502.201-.803.804-.602 1.407.2.502.803.803 1.305.602 4.72-1.808 7.23-6.93 5.724-11.652Zm-3.916 2.913a1.907 1.907 0 0 1-1.908-1.909c0-1.004.903-1.908 1.908-1.908 1.004 0 1.908.803 1.908 1.908s-.804 1.909-1.908 1.909Z"
  }));
});
CartItems.displayName = 'CartItems';
CartItems.defaultProps = {
  'aria-label': 'CartItems'
};
export default CartItems;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/CartItems.js
// module id = 3744
// module chunks = 11